import ManageContentScreen from '../components/ManageContentScreen';

const ManageTraining = () => {
  return (
    <ManageContentScreen
      type="training"
      title="Manage Training"
      backPath="/profile"
    />
  );
};

export default ManageTraining;
